export default __webpack_public_path__ + "static/media/Letter L.72b111c5.mov";